// Mirrors the server's SESSION_NAME_PATTERN — the name sits inside a tag.
export const NAME_PATTERN = /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/;

export const NAME_HINT =
  'Lower-case letters and digits, words joined by - or _ (e.g. "joint")';

// Tag-safe as you type: lower-case, spaces → hyphens.
export const normalizeSessionName = (raw: string): string =>
  raw.toLowerCase().replace(/\s+/g, "-");

// Per managed event, the reason its name can't be saved. Blank is fine — it
// clears the name.
export function sessionNameErrors(
  names: Record<string, string>,
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [id, name] of Object.entries(names)) {
    if (name && !NAME_PATTERN.test(name)) out[id] = NAME_HINT;
  }
  return out;
}

// Whether any name differs from what is saved (missing and blank are equal).
export function sessionNamesDirty(
  rows: { managed_event_id: string; short_name: string | null }[],
  names: Record<string, string>,
): boolean {
  return rows.some(
    (r) => (r.short_name ?? "") !== (names[r.managed_event_id] ?? ""),
  );
}
